import { Seo } from "@/components/layout/Seo";
import { CtaButton } from "@/components/brand/CtaButton";

export default function NotFound() {
  return (
    <section className="grain flex min-h-[80vh] items-center bg-ink pt-32" data-testid="not-found">
      <Seo title="Page not found | VION Tech" description="The page you are looking for could not be found." noindex />
      <div className="shell relative z-[2]">
        <p className="eyebrow text-gold">404</p>
        <h1 className="mt-6 font-display text-5xl font-light text-white sm:text-7xl">This page doesn't exist.</h1>
        <div className="mt-10"><CtaButton to="/" testid="not-found-home-btn">Back to Home</CtaButton></div>
      </div>
    </section>
  );
}
